export const NEW_AUTHORIZATION_SET_TYPE = 'NEW_AUTHORIZATION_SET_TYPE'
export const NEW_AUTHORIZATION_SET_SPONSOR = 'NEW_AUTHORIZATION_SET_SPONSOR'
export const NEW_AUTHORIZATION_ERROR = 'NEW_AUTHORIZATION_ERROR'
export const NEW_AUTHORIZATION_SET_SPONSOR_FORM = 'NEW_AUTHORIZATION_SET_SPONSOR_FORM'
export const SET_SPONSOR_SEARCH_METHOD = 'SET_SPONSOR_SEARCH_METHOD'
export const SET_INPUTS_SPONSOR_SEARCH_VALUES = 'SET_INPUTS_SPONSOR_SEARCH_VALUES'
export const SEARCH_BENEFICIARIES = 'SEARCH_BENEFICIARIES'
export const BENEFICIARIES_SUCCESS = 'BENEFICIARIES_SUCCESS'
export const SET_BENEFICIARY_SELECTED = 'SET_BENEFICIARY_SELECTED'
export const SET_BENEFICIARY_SELECTION = 'SET_BENEFICIARY_SELECTION'
export const COMPLETE_TYPE_STEP = 'COMPLETE_TYPE_STEP'
export const COMPLETE_SPONSOR_STEP = 'COMPLETE_SPONSOR_STEP'
export const COMPLETE_METHOD_STEP = 'COMPLETE_METHOD_STEP'
export const COMPLETE_BENEFICIARY_STEP = 'COMPLETE_BENEFICIARY_STEP'
export const COMPLETE_BENEFICIARY_SEARCH = 'COMPLETE_BENEFICIARY_SEARCH'
export const SET_NAVBAR_TYPE = 'SET_NAVBAR_TYPE'
export const CLEAR_NEW_AUTHORIZATION = 'CLEAR_NEW_AUTHORIZATION'

export const AUTHORIZATIONS_ERROR = 'AUTHORIZATIONS_ERROR'
export const AUTHORIZATIONS_SUCCESS = 'AUTHORIZATIONS_SUCCESS'
export const AUTHORIZATONS_LOADING = 'AUTHORIZATONS_LOADING'

export const SET_BENEFICIARY = 'SET_BENEFICIARY'
export const FIND_BENEFIRIARY_ERROR = 'FIND_BENEFIRIARY_ERROR'
export const SET_OUTPATIENT_CARE_FORM = 'SET_OUTPATIENT_CARE_FORM'
export const SET_BIOMETRIC_VERIFICATION_RESULT = 'SET_BIOMETRIC_VERIFICATION_RESULT'
export const SET_LOADING_VERIFICATION = 'SET_LOADING_VERIFICATION'
export const SET_CREATE_CLAIM_RESULT = 'SET_CREATE_CLAIM_RESULT'

export const SET_LOADING_CREATE_CLAIM = 'SET_LOADING_CREATE_CLAIM'
export const SET_CREATE_CLAIM_ERROR = 'SET_CREATE_CLAIM_ERROR'

export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_SET_ACCESS_TOKEN = 'AUTH_SET_ACCESS_TOKEN'
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const RESET_CHANGE_PASSWORD_STATUS = 'RESET_CHANGE_PASSWORD_STATUS'
export const CLIENT_TOKEN_ERROR = 'CLIENT_TOKEN_ERROR'
export const CLIENT_TOKEN_REQUEST = 'CLIENT_TOKEN_REQUEST'
export const CLIENT_TOKEN_SUCCESS = 'CLIENT_TOKEN_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const TERMS_AND_CONDITIONS_ERROR = 'TERMS_AND_CONDITIONS_ERROR'
export const TERMS_AND_CONDITIONS_REQUEST = 'TERMS_AND_CONDITIONS_REQUEST'
export const TERMS_AND_CONDITIONS_REQUIRED = 'TERMS_AND_CONDITIONS_REQUIRED'
export const TERMS_AND_CONDITIONS_SUCCESS = 'TERMS_AND_CONDITIONS_SUCCESS'
export const PASSWORD_ROTATION_UPDATED = 'PASSWORD_ROTATION_UPDATED'
export const SET_TOKEN = 'SET_TOKEN'
export const SETTLEMENTS_ERROR = 'SETTLEMENTS_ERROR'
export const SETTLEMENTS_SUCCESS = 'SETTLEMENTS_SUCCESS'
export const SETTLEMENTS_LOADING = 'SETTLEMENTS_LOADING'
export const SETTLEMENT_CREATION_SET_SPONSOR_SLUG = 'SETTLEMENT_CREATION_SET_SPONSOR_SLUG'
export const SETTLEMENT_CREATION_SET_DATE_FROM = 'SETTLEMENT_CREATION_SET_DATE_FROM'
export const SETTLEMENT_CREATION_SET_DATE_TO = 'SETTLEMENT_CREATION_SET_DATE_TO'
export const SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE = 'SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE'
export const SELECT_SETTLEMENT_FOR_DETAIL = 'SELECT_SETTLEMENT_FOR_DETAIL'
export const SET_SETTLEMENT_DETAIL = 'SET_SETTLEMENT_DETAIL'
export const CLEAN_SETTLEMENT_DETAIL = 'CLEAN_SETTLEMENT_DETAIL'
export const SETTLEMENT_CREATION_BACK_STEP = 'SETTLEMENT_CREATION_BACK_STEP'
export const SETTLEMENT_CREATION_NEXT_STEP = 'SETTLEMENT_CREATION_NEXT_STEP'
export const SET_PENDING_AUTHORIZATIONS = 'SET_PENDING_AUTHORIZATIONS'
export const SET_SETTLEMENT_ID = 'SET_SETTLEMENT_ID'
export const CLEAR_SETTLEMENT_CREATION = 'CLEAR_SETTLEMENT_CREATION'
export const SET_CLAIMS = 'SET_CLAIMS'
export const CLEAR_CLAIMS  = 'CLEAR_CLAIMS'
export const SET_EXCLUDED_CLAIMS = 'SET_EXCLUDED_CLAIMS'
export const CLEAR_EXCLUDED_CLAIMS = 'CLEAR_EXCLUDED_CLAIMS'
export const COMPLETE_ADD_AUTHORIZATIONS_STEP = 'COMPLETE_ADD_AUTHORIZATIONS_STEP'
export const SET_SETTLEMENT_CREATION_RESULT = 'SET_SETTLEMENT_CREATION_RESULT'


// DYNAMIC AUTHORIZATIONS
export const ADD_FILES = 'ADD_FILES'
export const AUTHORIZATION_COMMENT_LOADING = 'AUTHORIZATION_COMMENT_LOADING'
export const AUTHORIZATION_FORM_LOAD_SUCCESS = 'AUTHORIZATION_FORM_LOAD_SUCCESS'
export const AUTHORIZATION_LOADING = 'AUTHORIZATION_LOADING'
export const AUTHORIZATION_LOAD_SUCCESS = 'AUTHORIZATION_LOAD_SUCCESS'
export const AUTHORIZATION_LOAD_ERROR = 'AUTHORIZATION_LOAD_ERROR'
export const RESET_AUTHORIZATION_STATE = 'RESET_AUTHORIZATION_STATE'
export const SET_AUTHORIZATION = 'SET_AUTHORIZATION'
export const SET_AUTHORIZATION_ERROR = 'SET_AUTHORIZATION_ERROR'
export const SET_BENEFICIARY_ERROR = 'SET_BENEFICIARY_ERROR'
export const SET_CLAIM_TYPE = 'SET_CLAIM_TYPE'
export const SET_CURRENT_FORM = 'SET_CURRENT_FORM'
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP'
export const SET_ERROR = 'SET_ERROR'
export const SET_INPUTS = 'SET_INPUTS'
export const SET_IS_REIMBURSEMENT = 'SET_IS_REIMBURSEMENT'
export const SET_LIST_AUTHORIZATION = 'SET_LIST_AUTHORIZATION'
export const SET_REIMBURSEMENT_STATUS = 'SET_REIMBURSEMENT_STATUS'
export const SET_SPONSOR_SLUG = 'SET_SPONSOR_SLUG'
export const SET_STEP_ERROR = 'SET_STEP_ERROR'
export const SET_AUTHORIZATION_CREATED = 'SET_AUTHORIZATION_CREATED'

// DOCTOR ACTIONS
export const DOCTOR_INFORMATION_SUCCESS = 'DOCTOR_INFORMATION_SUCCESS'
export const DOCTOR_MEDICAL_LICENCE_SUCCESS = 'DOCTOR_MEDICAL_LICENCE_SUCCESS'
export const SET_DOCTOR_PROFILE = 'SET_DOCTOR_PROFILE'
export const SET_DOCTOR_PROFILE_LOADING = 'SET_DOCTOR_PROFILE_LOADING'
export const SET_DOCTOR_ERROR = 'SET_DOCTOR_ERROR'
export const GET_DOCTOR_PROFILE_LOADING = 'GET_DOCTOR_PROFILE_LOADING'
export const SET_VALIDATION_PROVIDER_EMAIL = 'SET_VALIDATION_PROVIDER_EMAIL'
export const SET_PROVIDER_STATUS = 'SET_PROVIDER_STATUS'
export const SET_ORIGINAL_PROFILE = 'SET_ORIGINAL_PROFILE'
export const MODIFY_PROFILE = 'MODIFY_PROFILE'